<app-navbar *ngIf="!isProd"></app-navbar>

<!-- Loading container for displaying the loading spinner and messages -->
<div *ngIf="disablePage$ | async" class="loading-container">
    <div class="loading-content">
        
        <!-- Loading spinner with conditions to stop spinning and fade-out -->
        <div class="loading-spinner mb-3"
            [ngClass]="{'fade-out': !(disablePage$ | async), 'stop-spin': stopSpinner$ | async}">
        </div>

        <!-- Loading text based on conditions -->
        <div *ngIf="!(stopSpinner$ | async)">
            <p class="loading-text" [ngClass]="{'fade-out': !(disablePage$ | async)}"> Loading CI Platform data...</p>
        </div>
        <div *ngIf="stopSpinner$ | async">
            <div *ngIf="!(noConfigData$ | async)">
                <p class="loading-text">Sorry, your URL seems to be incomplete...</p>
            </div>
            <div *ngIf="noConfigData$ | async">
                <p class="loading-text">Sorry, config data can't be loaded...</p>
            </div>
        </div>
    </div>
</div>

<!-- Fieldset to disable/blur the content based on the disablePage condition -->
<fieldset [disabled]="disablePage$ | async"
    [ngClass]="{'blur': disablePage$ | async, 'no-blur': !(disablePage$ | async)}">
    <router-outlet></router-outlet>
</fieldset>